// Using Angular Configurations in Angular.Json
// Refer to https://blog.angulartraining.com/how-to-manage-different-environments-with-angular-cli-883c26e99d15
// Please do not put UAT or Prod settings here.  Use npm run build-prod or npm run build-uat, to et the appropriate environment file used.

import { BrandPrefixEnum } from "./brand-prefix.enum";
import { EnvironmentPrefixEnum } from "./enviroments-prefix.enum";

export const environment = {
  production: false,
  // development
  identityApiUrl: 'https://privalgo-identity.azurewebsites.net/api',
  customerApiUrl: 'https://privalgo-module.azurewebsites.net/api',
  pricingSignalRUrl: 'https://privalgo-pricing.azurewebsites.net/updatePrice',
  pricingApiUrl: 'https://privalgo-pricing.azurewebsites.net/api',
  crmIntegrationApiUrl: 'https://privalgo-crm-integration.azurewebsites.net/api',

  // local test
  // identityApiUrl: 'http://192.168.152.8:8686/api',
  // customerApiUrl: 'http://192.168.152.8:8686/api',
  // pricingSignalRUrl: 'http://192.168.152.8:8686/updatePrice',
  // pricingApiUrl: 'http://192.168.152.8:8686/api',
  // crmIntegrationApiUrl: 'http://192.168.152.8:8686/api',

  // customerApiUrl: 'https://localhost:44390/api',
  // identityApiUrl: 'https://localhost:44328/api',
  // storeApiUrl: 'http://192.168.152.8:8686/api',
  // pricingSignalRUrl: 'http://192.168.152.8:8585/updatePrice',
  // pricingApiUrl: 'http://192.168.152.8:8585/api',
  storeName: 'LocalStorage',
  clientId: 'privalgo-portal',
  pageSize: 20,
  defaultLanguage: 'en',
  appInsights: {
    instrumentationKey: '234e1dd1-0d2d-4a23-a099-fcdb5f1c3fe6'
  },
  timeFreshtokenSec: 15 * 60,
  idleSec: 60 * 60,
  timeoutSec: 1 * 60,
  defaultPageSize: 50,
  maxSize: 5,
  recaptchaV2SiteKey: '6LePWCkaAAAAANyz9NMnzsVNHRkoVCBEJdz_bUtg',
  checkVersion: false,
  timeCheckVersion: 5 * 60 * 1000, // check every 5 minutes,
  brandPrefix: BrandPrefixEnum.Pml,
  environmentPrefix: EnvironmentPrefixEnum.PmlDev,
  tenantId: '1d03f2e1-04a8-48cd-8354-f50ec4e7b3c4',
  isPrivalgoMarkets: true,
  brandName: 'Privalgo Markets',
  domain: 'privalgomarkets.co.uk',
  phone: '+44 (0)20 3443 9292'
};

/*
 yse* In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 *
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
